import React from 'react'
import { Drawer, Container, Box, Typography } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  openDrawer: {
    ...theme.sidebar,
    width: '35%'
  }
}))

export const Typographys = () => {
  const classes = useStyles()

  return (
    <Drawer
      variant="permanent"
      anchor="right"
      classes={{ paper: classes.openDrawer }}
    >
      <Container>
        <Box>
          <Typography variant="h1" component="div" gutterBottom>
            h1. Heading
          </Typography>
          <Typography variant="h2" gutterBottom component="div">
            h2. Heading
          </Typography>
          <Typography variant="h3" gutterBottom component="div">
            h3. Heading
          </Typography>
          <Typography variant="h4" gutterBottom component="div">
            h4. Heading
          </Typography>
          <Typography variant="h5" gutterBottom component="div">
            h5. Heading
          </Typography>
          <Typography variant="h6" gutterBottom component="div">
            h6. Heading
          </Typography>
          <Typography variant="subtitle1" gutterBottom component="div">
            subtitle1.
          </Typography>
          <Typography variant="subtitle2" gutterBottom component="div">
            subtitle2.
          </Typography>
          <Typography variant="body1" gutterBottom>
            body1.
          </Typography>
          <Typography variant="body2" gutterBottom>
            body2.
          </Typography>
          <Typography variant="button" display="block" gutterBottom>
            button text
          </Typography>
          <Typography variant="caption" display="block" gutterBottom>
            caption text
          </Typography>
          <Typography variant="overline" display="block" gutterBottom>
            overline text
          </Typography>
        </Box>
      </Container>
    </Drawer>
  )
}
